import React from 'react';
import styled from 'styled-components';

import Contain from './contain';
import Title from './title';

const Section = styled.section`
  padding: 5rem 0;
  position: relative;
`;

const Row = styled.div`
  @media (min-width: 50rem) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 -1rem;
  }
`;

const Column = styled.div`
  @media (min-width: 50rem) {
    width: 40%;
    padding: 0 1rem;

    &:last-child {
      width: 60%;
    }
  }
`;

const Description = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 2.5rem;
`;

const Ul = styled.ul`
  margin-bottom: 2.5rem;
`;

const Li = styled.li`
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8.191' r='7.5' fill='%23fff' stroke='%230070E0'/%3E%3Ccircle cx='8' cy='8.191' r='5' fill='%230070E0'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: left 3px;
  padding: 0 0 .5rem 1.5rem;
`;

const Img = styled.img`
  @media (min-width: 50rem) {
    transform: scale(1.2, 1.2);
    margin-left: 2rem;
  }
`;

const BG = styled.img`
  position: absolute;
  z-index: -1;
  @media (min-width: 50rem) {
    top: -20%;
    right: 49%;
  }

  @media (max-width: 50rem) {
    top: 8%;
    right: 0;
    transform: scale(1.5, 1.5);
  }
`;


export default props => {
  return (
    <Section>
      <Contain>
        <BG src="https://quickpage-assets.s3.amazonaws.com/public/marketing/bg-fb.svg" alt="" />
        <Row>
          <Column>
            <Title>Exclusive Quickpage Facebook Membership.</Title>
            <Description>
              As a subscriber, you will receive access to our private Facebook group full of 1000s of Quickpage users from across the continent sharing never-before-seen  follow up strategies.
            </Description>
            <Ul>
              <Li>See exactly how other agents are winning with Quickpage</Li>
              <Li>Join weekly webinars to speed up your success </Li>
              <Li>Participate in drawings and giveaways</Li>
              <Li>Learn tips and techniques from sales leaders across multiple industries </Li>
            </Ul>
          </Column>

          <Column>
            <Img src="https://quickpage-assets.s3.amazonaws.com/public/marketing/facebook-group-re.png" alt="Exclusive Quickpage Facebook Membership." />
          </Column>
        </Row>
      </Contain>
    </Section>
  )
}
